import { ArrowLeft, ArrowRight } from 'lucide-react'
import { NaviFilter, PaginationProp } from '../../interface/interfaces'
import './pagination.scss'

type Prop={
paginationData:PaginationProp,
handlePageIncrement:(value:number)=> void,
setNaviFilter:React.Dispatch<React.SetStateAction<NaviFilter>>
}

const Pagination=({paginationData,handlePageIncrement,setNaviFilter}:Prop)=>{

const goToPage = (num: number) => {
        setNaviFilter((prev) => {
            return {
                ...prev,
                currentPage: num
            }
        })
    }



return (
    <div className="paginationBox">

                    {(paginationData.page - 1) >= 1 && (<div className="eachP  previous" onClick={() => handlePageIncrement(-1)}>
                        <ArrowLeft size={18}></ArrowLeft>
                        <span>Previous</span>
                    </div>)}

                    <div className="pages">

                        {paginationData.pages >= 1 && (<div className={`eachP num ${paginationData.page === 1 ? 'activepnum' : ''}`} onClick={() => goToPage(1)}>1</div>)}


                        {paginationData.pages >= 2 && (<div className={`eachP num ${paginationData.page === 2 ? 'activepnum' : ''}`} onClick={() => goToPage(2)}>2</div>)}


                        {paginationData.pages >= 3 && (<div className={`eachP num ${paginationData.page === 3 ? 'activepnum' : ''}`} onClick={() => goToPage(3)}>3</div>)}


                        {paginationData.page > 3 && (<>

                            <div className="eachP num">...</div>

                            <div className={`eachP num activepnum`}>{paginationData.page}</div>
                        </>)}

                    </div>

                    {paginationData.page + 1 <= paginationData.pages && (<div className="eachP next" onClick={() => handlePageIncrement(+1)}>
                        <span>Next</span>
                        <ArrowRight size={18}></ArrowRight>
                    </div>)}

                </div>
)
}

export default Pagination